/*存放一些不需要实时渲染的全局变量*/

//地图相关请求http://test.pro.brtbeacon.com.cn https://h5v2.pro.brtbeacon.com.cn //https://cicdi-sz-huizhan.pro.brtbeacon.com.cn:10111

export const HOST = 'https://cicdi-sz-huizhan.pro.brtbeacon.com.cn:10111';//https://201.test.dtuyun.com:10202  https://cicdi-sz-huizhan.pro.brtbeacon.com.cn:10111 http://192.168.1.194:81

//获取微信用户信息接口
export const WXUSERHOST = 'https://crh.pro.brtbeacon.net';

//数据上报域名
export const updataHOST = 'https://110.test.dtuyun.com';

//特殊优化事件序列管控
export let mapEventManger = {
    mapQueryStatus:false,   //地图查询状态
    mapQueryEvents:[],      //查询准备后待操作事件序列

    mapWxReadyStatus:false, //微信是否准备就绪
    mapWxReadyEvents:[],    //准备完成待操作事件序列

    brandReadyStatus:false, //品牌LOGO问题处理
    brandReadyEvents:[]
}

//模块||流程新增开关属性
export let mapFunManger = {
    needLogin:false,                //是否需要登录
    collectAndFoots:0               //收藏夹及历史足迹 0:隐藏 1：本地 2线上
}


